import React from 'react';
import { useSelector } from 'react-redux';

import './SellFundSummary.scss';

import StepCollapsed from '../../Shared/StepCollapsed/StepCollapsed';
import {
  getSellSelectedFundsWithAmountCount,
  getSellTransactionTotal,
} from '../../../redux/modules/sellTransaction/sellTransaction.selectors';
import { getSelectedDeliveryMethod } from '../../../redux/modules/sellDeliveryMethod/sellDeliveryMethod.selectors';
import words from '../../../utils/words';
import { DELIVERY_IN_KIND } from 'src/settings/settings';

const SellFundSummary = ({ clickable, onEditClick }) => {
  const sellTotalAmount = useSelector(getSellTransactionTotal);
  const sellSelectedFundsWithAmountCount = useSelector(
    getSellSelectedFundsWithAmountCount
  );
  const deliveryMethod = useSelector(getSelectedDeliveryMethod);

  return sellTotalAmount ||
    (deliveryMethod === DELIVERY_IN_KIND &&
      sellSelectedFundsWithAmountCount > 0) ? (
    <div
      className={`sell-fund-summary ${
        clickable
          ? 'sell-fund-summary-pointer'
          : 'sell-fund-summary-non-pointer'
      }`}
      onClick={clickable && onEditClick}
    >
      <StepCollapsed>
        <span className="sell-fund-summary-text">
          {sellSelectedFundsWithAmountCount}{' '}
          {sellSelectedFundsWithAmountCount === 1 ? words.fund : words.funds}{' '}
          selected
        </span>
        <a
          id="sell-step-2-edit"
          className="college-branded-link sell-fund-summary-edit-link"
        >
          Edit
        </a>
      </StepCollapsed>
    </div>
  ) : null;
};

export default SellFundSummary;
